import React, { useId } from "react";
import type { PremiumTier } from "../../dataLayer/backendApi";
import "./tierStar.css";

const STAR_PATH =
  "M10.788 3.21C11.236 2.133 12.764 2.133 13.212 3.21L15.294 8.217L20.698 8.65C21.862 8.743 22.334 10.195 21.447 10.955L17.33 14.481L18.588 19.754C18.859 20.89 17.624 21.787 16.628 21.179L12 18.354L7.372 21.179C6.376 21.787 5.141 20.89 5.412 19.754L6.67 14.481L2.553 10.955C1.666 10.195 2.138 8.743 3.302 8.65L8.706 8.217L10.788 3.21Z";

type TierStarVariant = "rank" | "name" | "home" | "card";

function tierLabel(tier: PremiumTier): string {
  return `${tier[0].toUpperCase()}${tier.slice(1)} supporter`;
}

export function TierStar({
  tier,
  variant,
  className = "",
}: {
  tier: PremiumTier | null;
  variant: TierStarVariant;
  className?: string;
}) {
  const gradientId = `tier-star-gradient-${useId().replace(/[^a-zA-Z0-9_-]/g, "")}`;
  const label = tier ? tierLabel(tier) : "Premium feature";
  const classes = [
    "tier-star",
    `tier-star--${variant}`,
    `tier-star--${tier ?? "neutral"}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span
      className={classes}
      role="img"
      aria-label={label}
      title={label}
      data-tier-star={tier ?? "neutral"}
    >
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        {tier && (
          <defs>
            <radialGradient id={gradientId} cx="31%" cy="28%" r="82%" fx="19%" fy="14%">
              <stop className="tier-star__stop tier-star__stop--glint" offset="0%" />
              <stop className="tier-star__stop tier-star__stop--highlight" offset="30%" />
              <stop className="tier-star__stop tier-star__stop--base" offset="72%" />
              <stop className="tier-star__stop tier-star__stop--anchor" offset="100%" />
            </radialGradient>
          </defs>
        )}
        <path
          className="tier-star__shape"
          d={STAR_PATH}
          fill={tier ? `url(#${gradientId})` : undefined}
        />
      </svg>
    </span>
  );
}
